const sidebarContext = {
    computed: {
        sidebarContext() {
            // TODO: get a context for specified sidebar, maybe this should be a method?
            return {
                alertMessage: this.alertMessage,
                showAlert: this.$v.$error || (!this.$v.$error && this.selectedCount > 0),
                selectedItems: this.selectedItems,
                selectedCount: this.selectedCount,
                getItem: this.getItem,
                type: this.$v.$error ? 'warning' : 'success',
            };
        },
    },
    methods: {},
};

export default sidebarContext;
